

import React, { useEffect, useRef } from 'react'
import { ImagePath } from '../../../../assets/ImagePath';
import { toogleSideBar } from '../../../../state/actions/layout';
import ToggleFavoritesIcon from './ToggleFavoritesIcon';


const CollapsableSidebar = ({ currentTabName, currentBotName, isSideBar, dispatch, handleSetFavorite, showFavoritesIcon, isFavoriteBot }) => {
    return (
        <h1 className="text-size-14 font-semibold items-center gap-2 flex">
            <img
                src={ImagePath.toogleBar}
                role="button"
                className={isSideBar ? 'rotate-180 cursor-pointer w-[16px]' : 'w-[16px]'}
                onClick={() => dispatch(toogleSideBar())}
            />
            {currentTabName ? currentTabName : currentBotName ? (
                currentBotName
            ) : (
                <div className="h-6 w-32 bg-lightgray rounded animate-pulse" />
            )}
            {showFavoritesIcon && (
                <ToggleFavoritesIcon
                    isFavoriteBot={isFavoriteBot}
                    handleSetFavorite={handleSetFavorite}
                />
            )}
        </h1>
    )
};

export default CollapsableSidebar